import React from 'react';
import moment from 'moment';
import { toUSD } from "../../util/currency-formatter";
import CustomTable from "../table/table";
import './breakdown.scss';

const LaborCostsTable = ({ resourceAllocations, getAllocationCost, formatHours }) => {
  const laborColumns = [
    { field: "userName", title: "User" },
    { 
      field: "startTime", 
      title: "Start Time",
      render: (item) => moment(item.startTime).format('DD/MM/YYYY HH:mm')
    },
    { 
      field: "endTime", 
      title: "End Time",
      render: (item) => moment(item.endTime).format('DD/MM/YYYY HH:mm')
    },
    { 
      field: "hours", 
      title: "Hours",
      render: (item) => formatHours(item.startTime, item.endTime)
    },
    { field: "status", title: "Status" },
    { 
      field: "cost", 
      title: "Cost", 
      class: "text-right",
      render: (item) => <span className="text-right">{toUSD(getAllocationCost(item))}</span>
    }
  ];
  
  // Get total cost for resource allocations
  const totalCost = resourceAllocations.reduce((sum, allocation) => 
    sum + (allocation.status === 'APPROVED' ? getAllocationCost(allocation) : 0), 0);
  
  return (
    <div className="breakdown-container mt-3">
      {/* Main resource allocations table */}
      <CustomTable 
        columns={laborColumns}
        data={resourceAllocations}
        toolbar={true}
        exportButton={true}
        enableSearch={true}
        itemsPerPageCustom={false}
      />
      
      {/* Subtotal row as a separate table */}
      <div className="mt-3 border d-flex justify-content-between align-items-center p-2">
        <p className="mb-0 subtotal">Resource Subtotal</p>
        <p className="mb-0 subtotal">{toUSD(totalCost)}</p>
      </div>
    </div>
  );
};

export default LaborCostsTable; 